import { IssueKey, type IssuesStore } from "services/issues/issuesStore";
import { QuestionsStore } from "services/questions/questionsStore";
import { DirectorShareAcnQuestion } from "./directorShareConstants";

export class DirectorShareQuestionsStore extends QuestionsStore<DirectorShareAcnQuestion> {
  protected _issueKey = IssueKey.Director;

  constructor(protected readonly _issuesStore: IssuesStore) {
    super(DirectorShareAcnQuestion, _issuesStore);
  }

  protected _getRelevantQuestion(): DirectorShareAcnQuestion | undefined {
    return undefined;
  }
}
